import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const feUserProfileApi = createAggrApiInstance(aggr.FrontendUserProfileApi)

export const updateUserName = async (newDisplayName: string) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileUpdatename({ newDisplayName }))
  return res
}

export const requestUpdateEmail = async (newEmail: aggr.FEUserProfileRequestEmailChangeRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileRequestemailchange(newEmail))
  return res
}

export const verifyEmailUpdate = async (reqData: aggr.FEUserProfileVerifyEmailChangeRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileVerifyemailchange(reqData))
  return res
}

export const resendVerificationCode = async (reqData: aggr.FEUserProfileResendVerificationCodeRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileResendverificationcode(reqData))
  return res
}

export const getUserPhoneNumber = async () => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileGetphonenumber())
  return res
}

export const updateUserPhoneNumber = async (reqData: aggr.FEUserProfileUpdatePhoneNumberRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileUpdatephonenumber(reqData))
  return res
}

export const updateUserPassword = async (reqData: aggr.FEUserProfileUpdatePasswordRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileUpdatepassword(reqData))
  return res
}

export const updateUserAvatar = async (reqData: any) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileUploadimage(reqData))
  return res
}

export const removeUserAvatar = async () => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileRemoveuseravatar())
  return res
}

export const getUserSSOAccounts = async () => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileGetcurrentuserbindssoaccounts())
  return res
}

export const bindUserSSOToken = async (reqData: aggr.UserProfileBindSsoTokenRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileBindssotoken(reqData))
  return res
}

export const removeUserSSOAccount = async (reqData: aggr.UserProfileDeleteCurrentUserBindSsoAccountRq) => {
  const res = await handleApiStatus(() => feUserProfileApi.userprofileDeletecurrentuserbindssoaccount(reqData))
  return res
}
